import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Alert, AlertTitle } from "@mui/material";
import { Toaster, toast } from "sonner";
import { useDirect } from "../../hooks";
import keyNames from "../../keyName";
const CustomToast = () => {
  const storeData = useSelector((state) => state.mainReducer);
  const { toastData } = storeData;
  const directDispatch = useDirect();
  const [position, setPosition] = useState("top-right");
  useEffect(() => {
    if (toastData) {
      toastData?.position && setPosition(toastData.position);
      toast.custom(
        (t) => (
          <Alert
            severity={toastData.type}
            onClose={() => toast.dismiss(t)}
            style={{
              background: "#ffffff",
              color: "#1a0505",
              boxShadow: "0 4px 24px rgba(232,42,42,0.22)",
              borderRadius: "12px",
              border: "1px solid rgba(232,42,42,0.18)",
              minWidth: "320px",
              opacity: 1,
            }}
            sx={{
              "& .MuiAlert-icon": { alignItems: "center" },
              "& .MuiAlertTitle-root": { fontWeight: 700, color: "#1a0505" },
              "& .MuiAlert-message": { color: "#374151" },
            }}
          >
            <AlertTitle>{toastData.title}</AlertTitle>
            {toastData.description}
          </Alert>
        ),

        {
          onAutoClose: (t) => toast.dismiss(t),
          onDismiss: (t) => toast.dismiss(t),
        }
      );
      directDispatch(null, keyNames.toastData);
    }
  }, [toastData, directDispatch]);
  return (
    <Toaster
      position={position}
      closeButton
      visibleToasts={5}
      duration={5000}
      toastOptions={{
        style: {
          background: "#ffffff",
          border: "none",
          padding: 0,
          boxShadow: "none",
          opacity: 1,
        },
      }}
    />
  );
};
export default CustomToast;
